// 複数機能で使用するPID関連の関数を定義する。

/**
 * PID(翻訳キーを含む)をPID形式からDID形式に変換する
 * @param {string} id DID/PID
 * @returns DID
 */
export const convertKeyForPidToDid = (id) => {
    if (!id) {
        return id;
    }
    return id.replace(/^([A-F0-9]{2})_/, 'F4$1_').replace(/over_([A-F0-9]{2})_/, 'over_F4$1_');
};